module.exports = __webpack_public_path__ + "img/去开盲盒.7e0c0172.png";